import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";

const CreatePassword = ({ isDisabled, isEyeIcon }) => {
  const {
    formState: { errors },
  } = useFormContext();
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });

  const changeShowPassword = (type) => {
    setShowPassword((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  return (
    <div>
      <div className="question-heading">What is your email address?</div>
      <div className="form-fields">
        <SurveyFormField name="email" type="email" isDisabled={isDisabled} />
        {errors.email && <div className="error">{errors.email.message}</div>}
      </div>

      <div className="question-heading">Create a new password to continue.</div>
      <div className="form-fields">
        <SurveyFormField
          name="password"
          placeHolder="Password"
          type={showPassword.password ? "text" : "password"}
          endAdornment={
            isDisabled ? undefined : (
              <div className={`position-absolute marks-adornment ${isEyeIcon ? "d-none" : ""}`}>
                {showPassword.password ? (
                  <IoIosEye
                    className="reset-field-icon-password pointer"
                    onClick={() => changeShowPassword("password")}
                  />) :
                  (<IoIosEyeOff
                    className="reset-field-icon-password pointer"
                    onClick={() => changeShowPassword("password")}
                  />)
                }
              </div>
            )
          }
          isDisabled={isDisabled}
        />
        {errors.password && (
          <div className="error">{errors.password.message}</div>
        )}
        <div className="mt-3">
          <SurveyFormField
            name="confirmPassword"
            placeHolder="Confirm Password"
            type={showPassword.confirmPassword ? "text" : "password"}
            endAdornment={
              isDisabled ? undefined : (
                <div className={`position-absolute marks-adornment ${isEyeIcon ? "d-none" : ""}`}>
                  {showPassword.confirmPassword ? (
                    <IoIosEye
                      className="reset-field-icon-password pointer"
                      onClick={() => changeShowPassword("confirmPassword")}
                    />
                  ) :
                    (
                      <IoIosEyeOff
                        className="reset-field-icon-password pointer"
                        onClick={() => changeShowPassword("confirmPassword")}
                      />
                    )}
                </div>
              )
            }
            isDisabled={isDisabled}
          />
          {errors.confirmPassword && (
            <div className="error">{errors.confirmPassword.message}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreatePassword;
